<template>
    <portfolio-single :items="items">
        <template v-slot:image>
            <a href="https://www.bullybreedersassociation.com/"
                ><img
                    src="../../../assets/images/bully-breeders-association.png"
                    alt="Bully Breeder's Association"
                    width="1411"
                    height="931"
            /></a>
        </template>
        <template v-slot:title>Dog Registry</template>
        <template>
            <p>
                Built in WordPress with WooCommerce and Gravity Forms, custom
                plugins allows registration numbers to be auto-generated and
                auto-incremented and for registration certificates to be
                dynamically created into a PDF on the click of a button.
            </p>
        </template>
        <template v-slot:link>
            <a href="https://www.bullybreedersassociation.com/"
                >bullybreedersassociation.com</a
            >
        </template>
    </portfolio-single>
</template>

<script>
export default {
    data() {
        return {
            items: [
                'Custom designed',
                'Ecommerce',
                'Powered by WordPress',
                'Copywriting services',
                'Responsive / mobile friendly',
                'Custom programming',
            ],
        };
    },
};
</script>
